import { styled } from '@mui/system';

const GroupItems = styled('ul')({
  padding: 0,
});


export default GroupItems;
